import { css } from 'linaria';

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 58px);
`;

export const image = css`
  margin-bottom: var(--space-400);
`;

export const title = css`
  margin-bottom: var(--space-100);
`;

export const description = css`
  margin-bottom: var(--space-300);
`;
